import { FormControl, ValidatorFn } from '@angular/forms';

import { ErrorType } from '@constants/error.constant';
import { FormHelper } from '@helpers/form.helper';
import { ValidatorHelper } from '@helpers/validators.helper';
import { ErrorMessage } from '@interfaces/error-message';

export class EmailFormControl extends FormControl<string> {
  get errorMessage(): ErrorMessage {
    return FormHelper.composeErrorMessages(this, [
      { method: 'getEmptyErrorMessage', args: ['Email requis'] },
      {
        method: 'simpleErrorMessage',
        args: [
          {
            simpleErrorCode: ErrorType.EMAIL,
            simpleErrorMessage: 'Email invalide'
          }
        ]
      }
    ]);
  }

  constructor(value: string, extraValidators: ValidatorFn[]) {
    const validators = [ValidatorHelper.emailValidator(), ...extraValidators];
    super(value, { validators });
  }
}
